import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'components/molecules'
import { Title } from 'components/atoms'
import { useHistory } from 'react-router-dom'
import { useUserContext, actions } from 'context/UserContext';

import SubwebCreateForm from './SubwebCreateForm'

const SubwebCreateModal = ({ isOpen, toggle }) => {
  const history = useHistory()
  const [{ userAuthenticated }, dispatch] = useUserContext()
  const handleSubmit = ({
    slug,
    namePt,
    nameEn,
    description,
    initials,
    color,
    serviceId,
  }) => {
    toggle()
    if (userAuthenticated) {
      dispatch({
        type: actions.ADD_USER_SUBWEB,
        data: {
          slug,
          namePt,
          nameEn,
          description,
          initials,
          color,
          id: serviceId,
        }
      });
    }
    history.push(`/${slug}`)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <Modal.Top>
        <Title>
            Criar subweb
        </Title>
      </Modal.Top>
      <SubwebCreateForm
        initialValues={{}}
        onSubmit={handleSubmit}
        onDiscard={toggle}
      />
    </Modal>
  )
}

SubwebCreateModal.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

SubwebCreateModal.defaultProps = {
  isOpen: false,
  toggle: () => {}
}

export default SubwebCreateModal
